import axios from "axios";

export default {
  data() {
    return {
      persons: [],
      namePersons: [],
      researchAreas: [],
      congressEditions: [],
      journals: [],
      editorials: [],
      publicationStatus: [],
      communicationTypes: [],
      bookAndChapterTypes: [],
      doctoralPrograms: [],
      gradeOptions: [],
      languageOptions: [],
      minervaSyncOptions: [],
      minervaSyncStates: []
    };
  },

  methods: {
    getPersons() {
      let path = this.$store.state.endpoint + "/person";
      axios
        .get(path)
        .then(response => {
          this.persons = response.data.sort((a, b) => { return a.preferred_name.family_name > b.preferred_name.family_name; })
        })
        .catch(error => {
          console.log(error);
        });
    },
    getNamePersons() {
      let path = this.$store.state.endpoint + "/personName";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(item => {
            this.namePersons.push({
              id: item.id,
              name:
                item.preferred_name.given_name +
                " " +
                item.preferred_name.family_name
            });
          });
          this.namePersons.sort((a, b) => { return a.name > b.name; })
        })
        .catch(error => {
          console.log(error);
        });
    },
    getResearchAreas() {
      let path = this.$store.state.endpoint + "/researchArea";
      axios
        .get(path)
        .then(response => {
          this.researchAreas = response.data.filter(area => !(area.closed || area.deprecated))
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAllResearchAreas() {
      let path = this.$store.state.endpoint + "/researchArea";
      axios
          .get(path)
          .then(response => {
            this.researchAreas = response.data;
          })
          .catch(error => {
            console.log(error);
          });
    },
    getCongressEditions() {
      let path = this.$store.state.endpoint + "/congressEdition";
      axios
        .get(path)
        .then(response => {
          this.congressEditions = response.data.sort((a, b) => { return a.name > b.name; })
        })
        .catch(error => {
          console.log(error);
        });
    },

    getJournals() {
      let path = this.$store.state.endpoint + "/journal";
      axios
        .get(path)
        .then(response => {
          this.journals = response.data.sort((a, b) => { return a.title > b.title; })
        })
        .catch(error => {
          console.log(error);
        });
    },

    getEditorials() {
      let path = this.$store.state.endpoint + "/editorial";
      axios
        .get(path)
        .then(response => {
          this.editorials = response.data.sort((a, b) => { return a.name > b.name; })
        })
        .catch(error => {
          console.log(error);
        });
    },

    getPublicationStatus() {
      let path = this.$store.state.endpoint + "/utils/publicationsStatus";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(item => {
            this.publicationStatus.push({
              text: this.$t("publication.status." + item),
              value: item
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getLanguageOptions() {
      let path = this.$store.state.endpoint + "/utils/languages";
      axios
        .get(path)
        .then(response => {
          this.languageOptions = response.data
            .map(code => {
              const key = "publication.languages." + code;
              const text = this.$te(key) ? this.$t(key) : code.toUpperCase();
              return { text, value: code };
            })
            .sort((a, b) => a.text.localeCompare(b.text));
        })
        .catch(error => {
          console.log(error);
        });
    },
    getMinervaSyncOptions() {
      let path = this.$store.state.endpoint + "/utils/minervaSyncOptions";
      axios
        .get(path)
        .then(response => {
          this.minervaSyncOptions = response.data.map(item => {
            const key = "publication.minervaVisibilityOptions." + item;
            const text = this.$te(key) ? this.$t(key) : item;
            return { text, value: item };
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getMinervaSyncStates() {
      let path = this.$store.state.endpoint + "/utils/minervaSyncStates";
      axios
        .get(path)
        .then(response => {
          this.minervaSyncStates = response.data.map(item => {
            const key = "publication.minervaSyncStates." + item;
            const text = this.$te(key) ? this.$t(key) : item;
            return { text, value: item };
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    getCommunicationTypes() {
      let path = this.$store.state.endpoint + "/utils/communicationTypes";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(item => {
            this.communicationTypes.push({
              text: this.$t("publication.communication.types." + item),
              value: item
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    getBookAndChapterTypes() {
      let path = this.$store.state.endpoint + "/utils/bookAndChapters";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(item => {
            this.bookAndChapterTypes.push({
              text: this.$t("publication.bookAndChapter.types." + item),
              value: item
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDoctoralProgramOptions() {
      let path = this.$store.state.endpoint + "/utils/doctoralPrograms";
      axios
        .get(path)
        .then(response => {
          this.doctoralPrograms = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getGradeOptions() {
      let path = this.$store.state.endpoint + "/utils/gradeOptions";
      axios
        .get(path)
        .then(response => {
          this.gradeOptions = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
